/**
 * Branding Configuration
 *
 * This file provides tenant-specific branding configuration.
 * Values can be overridden via environment variables for different deployments.
 *
 * Environment Variables:
 * - REACT_APP_TENANT_NAME: The tenant/clinic name
 * - REACT_APP_TENANT_LOGO: URL to the tenant logo
 * - REACT_APP_TENANT_PRIMARY_COLOR: Primary brand color (hex)
 * - REACT_APP_TENANT_SECONDARY_COLOR: Secondary brand color (hex)
 */

// Default HearSay branding (fallback)
const DEFAULT_BRANDING = {
  tenantName: "HearSay",
  logo: "https://www.hearsay.ca/wp-content/uploads/2022/03/hearsay_logo_fnl_c.jpg",
  logoAlt: "HearSay Logo",
  primaryColor: "#4F46E5", // Indigo
  secondaryColor: "#10B981", // Emerald
  supportEmail: "support@hearsay.ca",
  companyWebsite: "https://www.hearsay.ca",
};

// Build branding config from environment variables with defaults
export const branding = {
  tenantName: process.env.REACT_APP_TENANT_NAME || DEFAULT_BRANDING.tenantName,
  logo: process.env.REACT_APP_TENANT_LOGO || DEFAULT_BRANDING.logo,
  logoAlt: process.env.REACT_APP_TENANT_NAME
    ? `${process.env.REACT_APP_TENANT_NAME} Logo`
    : DEFAULT_BRANDING.logoAlt,
  primaryColor: process.env.REACT_APP_TENANT_PRIMARY_COLOR || DEFAULT_BRANDING.primaryColor,
  secondaryColor: process.env.REACT_APP_TENANT_SECONDARY_COLOR || DEFAULT_BRANDING.secondaryColor,
  supportEmail: process.env.REACT_APP_TENANT_SUPPORT_EMAIL || DEFAULT_BRANDING.supportEmail,
  companyWebsite: process.env.REACT_APP_TENANT_WEBSITE || DEFAULT_BRANDING.companyWebsite,
};

// Helper function to get logo with fallback
export const getLogo = (clinicLogo) => {
  return clinicLogo || branding.logo;
};

// Helper function to get tenant name with fallback
export const getTenantName = (clinicName) => {
  return clinicName || branding.tenantName;
};

export default branding;
